import { memo, useCallback } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import identity from 'lodash/identity';

import { Checkbox } from 'shared/ui/Checkbox/Checkbox';

const TreeOption = (props) => {
  const {
    option,
    checked,
    visible,
    disabled,
    selectedOptions = [],
    onChange,
    getOptionId = identity,
    getOptionLabel = (_option, _props) => null,
    getOptionDescription = (_option, _props) => null,
  } = props;
  const handleChange = useCallback(
    (event) => {
      const nextSelectedOptions = event.target.checked
        ? [...selectedOptions, option]
        : selectedOptions.filter((selectedOption) => getOptionId(selectedOption) !== getOptionId(option));

      onChange(nextSelectedOptions);
    },
    [option, selectedOptions, onChange, getOptionId],
  );

  if (!option) {
    return null;
  }

  const id = getOptionId(option);

  const inputId = `tree-select-option-${id}`;

  const label = getOptionLabel(option, props);

  const description = getOptionDescription(option, props);

  const className = classnames({
    'tree-menu__option': true,
    'tree-menu__option_inline': !!visible,
    'tree-menu__option_hidden': !visible,
  });

  return (
    <div className={className}>
      <div className="angle margin-right" />
      {!disabled ? (
        <Checkbox
          label={label}
          inputId={inputId}
          checked={checked}
          disabled={disabled}
          labelClassName="tree-menu__option-label"
          onChange={handleChange}
        />
      ) : (
        <span>{label}</span>
      )}
      {description && <p>{description}</p>}
    </div>
  );
};

TreeOption.propTypes = {
  option: PropTypes.oneOfType([PropTypes.object, PropTypes.number, PropTypes.string]),
  checked: PropTypes.bool,
  visible: PropTypes.bool,
  disabled: PropTypes.bool,
  selectedOptions: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.object), PropTypes.object]),
  onChange: PropTypes.func.isRequired,
  getOptionId: PropTypes.func,
  getOptionLabel: PropTypes.func,
};

// eslint-disable-next-line import/no-default-export
export default memo(TreeOption);
